import React from 'react';

const distributionName = process.env.REACT_APP_DISTRIBUTION_NAME || 'GasCheck';

const AppFooter = () => {
    return (
        <div className="layout-footer">
            <div>
                <p>{distributionName}</p>
            </div>
            <div className="footer-info">
                <p>&copy; {new Date().getFullYear()} GasCheck. All rights reserved.</p>
            </div>
        </div>
    );
};

export default AppFooter;
